import { fetchData } from "@client";

export async function getTermsArticleQuery() {
  return await fetchData("/article/1");
}
